if (!customElements.get("countdown-timer")) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.interval = null;
      this.slider = null;
      this.swiper = null;
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this.slider = this.querySelector(".countdown-timer__slider");
      this.onResize();
      window.addEventListener("resize", this.onResize);
      this.initTimer();
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.onResize);
      this.destroySlider();
      if (this.interval) clearInterval(this.interval);
    }

    initTimer() {
      const counterEl = this.querySelector(".countdown-timer__counter");
      if (!counterEl) return;

      const endDateAttr = counterEl.getAttribute("data-end-date");
      if (!endDateAttr) return console.error("Missing data-end-date attribute");

      const countDownDate = new Date(endDateAttr).getTime();
      if (isNaN(countDownDate)) return console.error("Invalid data-end-date");

      const convertingNumbersToMarkup = (number) => {
        const str = number.toString().padStart(2, "0");
        return [...str].map((d) => `<span>${d}</span>`).join("");
      };

      const updateTimer = () => {
        const now = Date.now();
        let distance = countDownDate - now;

        if (distance <= 0) {
          clearInterval(this.interval);
          distance = 0;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (distance % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        this.querySelector("#days").innerHTML = convertingNumbersToMarkup(days);
        this.querySelector("#hours").innerHTML = convertingNumbersToMarkup(hours);
        this.querySelector("#minutes").innerHTML = convertingNumbersToMarkup(minutes);
        this.querySelector("#seconds").innerHTML = convertingNumbersToMarkup(seconds);
      };

      updateTimer(); 
      this.interval = setInterval(updateTimer, 1000);
    }

    initSlider() {
      if(!this.slider) return;

      const autoplayDelay = parseInt(this.slider.dataset.autoplayDelay);
      const initialSlideIndex = parseInt(this.slider.dataset.initialSlideIndex || 0);
      
      const swiperOptions = {
        slidesPerView: 1.22,
        spaceBetween: 18,
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        initialSlide: initialSlideIndex,
      
        breakpoints: {
          767: {
            slidesPerView: 2,
          }
        }
      };

      if (autoplayDelay && autoplayDelay > 0) {
        swiperOptions.autoplay = {
          delay: autoplayDelay * 1000,
          disableOnInteraction: false,
        };
      }

      this.swiper = new Swiper(this.slider, swiperOptions);
    }

    onResize() {
      const isMobile = window.innerWidth <= 1023;
      
      if (isMobile && !this.swiper) {
        this.initSlider();
      } else if (!isMobile && this.swiper) {
        this.destroySlider();
      }
    }

    destroySlider() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define("countdown-timer", CountdownTimer);
}
